const Coop: any = (
  style = {},
  fill = '#000',
  width = '100%',
  height = '100%',
  viewBox = '0 0 60 65',
) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M34 64.0498C33.447 64.0498 33 63.6028 33 63.0498V50.0498C33 49.4968 33.447 49.0498 34 49.0498C34.553 49.0498 35 49.4968 35 50.0498V63.0498C35 63.6028 34.553 64.0498 34 64.0498Z"
      fill={fill}
    />
    <path
      d="M26 64.0498C25.447 64.0498 25 63.6028 25 63.0498V50.0498C25 49.4968 25.447 49.0498 26 49.0498C26.553 49.0498 27 49.4968 27 50.0498V63.0498C27 63.6028 26.553 64.0498 26 64.0498Z"
      fill={fill}
    />
    <path
      d="M34 51.0498H26C25.447 51.0498 25 50.6028 25 50.0498C25 49.4968 25.447 49.0498 26 49.0498H34C34.553 49.0498 35 49.4968 35 50.0498C35 50.6028 34.553 51.0498 34 51.0498Z"
      fill={fill}
    />
    <path
      d="M34 64.0498H26C25.447 64.0498 25 63.6028 25 63.0498C25 62.4968 25.447 62.0498 26 62.0498H34C34.553 62.0498 35 62.4968 35 63.0498C35 63.6028 34.553 64.0498 34 64.0498Z"
      fill={fill}
    />
    <path
      d="M34 45.0498H26C25.447 45.0498 25 44.6028 25 44.0498V32.0498C25 31.4968 25.447 31.0498 26 31.0498H34C34.553 31.0498 35 31.4968 35 32.0498V44.0498C35 44.6028 34.553 45.0498 34 45.0498ZM27 43.0498H33V33.0498H27V43.0498Z"
      fill={fill}
    />
    <path
      d="M30 45.0498C29.447 45.0498 29 44.6028 29 44.0498V32.0498C29 31.4968 29.447 31.0498 30 31.0498C30.553 31.0498 31 31.4968 31 32.0498V44.0498C31 44.6028 30.553 45.0498 30 45.0498Z"
      fill={fill}
    />
    <path
      d="M34 37.0498H26C25.447 37.0498 25 36.6028 25 36.0498C25 35.4968 25.447 35.0498 26 35.0498H34C34.553 35.0498 35 35.4968 35 36.0498C35 36.6028 34.553 37.0498 34 37.0498Z"
      fill={fill}
    />
    <path
      d="M34 41.0498H26C25.447 41.0498 25 40.6028 25 40.0498C25 39.4968 25.447 39.0498 26 39.0498H34C34.553 39.0498 35 39.4968 35 40.0498C35 40.6028 34.553 41.0498 34 41.0498Z"
      fill={fill}
    />
    <path
      d="M34 27.0498H26C25.447 27.0498 25 26.6028 25 26.0498V14.0498C25 13.4968 25.447 13.0498 26 13.0498H34C34.553 13.0498 35 13.4968 35 14.0498V26.0498C35 26.6028 34.553 27.0498 34 27.0498ZM27 25.0498H33V15.0498H27V25.0498Z"
      fill={fill}
    />
    <path
      d="M30 27.0498C29.447 27.0498 29 26.6028 29 26.0498V14.0498C29 13.4968 29.447 13.0498 30 13.0498C30.553 13.0498 31 13.4968 31 14.0498V26.0498C31 26.6028 30.553 27.0498 30 27.0498Z"
      fill={fill}
    />
    <path
      d="M34 19.0498H26C25.447 19.0498 25 18.6028 25 18.0498C25 17.4968 25.447 17.0498 26 17.0498H34C34.553 17.0498 35 17.4968 35 18.0498C35 18.6028 34.553 19.0498 34 19.0498Z"
      fill={fill}
    />
    <path
      d="M34 23.0498H26C25.447 23.0498 25 22.6028 25 22.0498C25 21.4968 25.447 21.0498 26 21.0498H34C34.553 21.0498 35 21.4968 35 22.0498C35 22.6028 34.553 23.0498 34 23.0498Z"
      fill={fill}
    />
    <path
      d="M38.9989 7.0499C38.8349 7.0499 38.6679 7.0099 38.5149 6.9239L29.5149 1.9239C29.0319 1.6549 28.8579 1.0469 29.1259 0.5649C29.3939 0.0829 30.0029 -0.0931 30.4849 0.1759L39.4849 5.1759C39.9679 5.4449 40.1419 6.0529 39.8739 6.5349C39.6909 6.8639 39.3509 7.0499 38.9989 7.0499Z"
      fill={fill}
    />
    <path
      d="M21.0005 7.04982C20.6485 7.04982 20.3085 6.86382 20.1255 6.53482C19.8565 6.05282 20.0305 5.44382 20.5145 5.17582L29.5145 0.175819C29.9965 -0.0941815 30.6055 0.0818185 30.8735 0.564819C31.1415 1.04782 30.9685 1.65582 30.4845 1.92382L21.4845 6.92382C21.3315 7.00982 21.1645 7.04982 21.0005 7.04982Z"
      fill={fill}
    />
    <path
      d="M38.9989 11.0499C38.8349 11.0499 38.6679 11.0099 38.5149 10.9239L29.5149 5.92386C29.0319 5.65486 28.8579 5.04686 29.1259 4.56486C29.3939 4.08286 30.0029 3.90586 30.4849 4.17586L39.4849 9.17586C39.9679 9.44486 40.1419 10.0529 39.8739 10.5349C39.6909 10.8639 39.3509 11.0499 38.9989 11.0499Z"
      fill={fill}
    />
    <path
      d="M21.0005 11.0498C20.6485 11.0498 20.3085 10.8638 20.1255 10.5348C19.8565 10.0528 20.0305 9.44377 20.5145 9.17577L29.5145 4.17577C29.9965 3.90477 30.6055 4.08177 30.8735 4.56477C31.1415 5.04777 30.9685 5.65577 30.4845 5.92377L21.4845 10.9238C21.3315 11.0098 21.1645 11.0498 21.0005 11.0498Z"
      fill={fill}
    />
    <path
      d="M21 64.0498C20.447 64.0498 20 63.6028 20 63.0498V6.0498C20 5.4968 20.447 5.0498 21 5.0498C21.553 5.0498 22 5.4968 22 6.0498V63.0498C22 63.6028 21.553 64.0498 21 64.0498Z"
      fill={fill}
    />
    <path
      d="M39 64.0498C38.447 64.0498 38 63.6028 38 63.0498V6.0498C38 5.4968 38.447 5.0498 39 5.0498C39.553 5.0498 40 5.4968 40 6.0498V63.0498C40 63.6028 39.553 64.0498 39 64.0498Z"
      fill={fill}
    />
    <path
      d="M28.0304 57.0498C27.4774 57.0498 27.0254 56.6028 27.0254 56.0498C27.0254 55.4968 27.4674 55.0498 28.0194 55.0498H28.0304C28.5824 55.0498 29.0304 55.4968 29.0304 56.0498C29.0304 56.6028 28.5824 57.0498 28.0304 57.0498Z"
      fill={fill}
    />
    <path
      d="M52 64.0498C51.447 64.0498 51 63.6028 51 63.0498V50.0498C51 49.4968 51.447 49.0498 52 49.0498C52.553 49.0498 53 49.4968 53 50.0498V63.0498C53 63.6028 52.553 64.0498 52 64.0498Z"
      fill={fill}
    />
    <path
      d="M44 64.0498C43.447 64.0498 43 63.6028 43 63.0498V50.0498C43 49.4968 43.447 49.0498 44 49.0498C44.553 49.0498 45 49.4968 45 50.0498V63.0498C45 63.6028 44.553 64.0498 44 64.0498Z"
      fill={fill}
    />
    <path
      d="M52 51.0498H44C43.447 51.0498 43 50.6028 43 50.0498C43 49.4968 43.447 49.0498 44 49.0498H52C52.553 49.0498 53 49.4968 53 50.0498C53 50.6028 52.553 51.0498 52 51.0498Z"
      fill={fill}
    />
    <path
      d="M52 64.0498H44C43.447 64.0498 43 63.6028 43 63.0498C43 62.4968 43.447 62.0498 44 62.0498H52C52.553 62.0498 53 62.4968 53 63.0498C53 63.6028 52.553 64.0498 52 64.0498Z"
      fill={fill}
    />
    <path
      d="M52 45.0498H44C43.447 45.0498 43 44.6028 43 44.0498V32.0498C43 31.4968 43.447 31.0498 44 31.0498H52C52.553 31.0498 53 31.4968 53 32.0498V44.0498C53 44.6028 52.553 45.0498 52 45.0498ZM45 43.0498H51V33.0498H45V43.0498Z"
      fill={fill}
    />
    <path
      d="M48 45.0498C47.447 45.0498 47 44.6028 47 44.0498V32.0498C47 31.4968 47.447 31.0498 48 31.0498C48.553 31.0498 49 31.4968 49 32.0498V44.0498C49 44.6028 48.553 45.0498 48 45.0498Z"
      fill={fill}
    />
    <path
      d="M52 37.0498H44C43.447 37.0498 43 36.6028 43 36.0498C43 35.4968 43.447 35.0498 44 35.0498H52C52.553 35.0498 53 35.4968 53 36.0498C53 36.6028 52.553 37.0498 52 37.0498Z"
      fill={fill}
    />
    <path
      d="M52 41.0498H44C43.447 41.0498 43 40.6028 43 40.0498C43 39.4968 43.447 39.0498 44 39.0498H52C52.553 39.0498 53 39.4968 53 40.0498C53 40.6028 52.553 41.0498 52 41.0498Z"
      fill={fill}
    />
    <path
      d="M52 27.0498H44C43.447 27.0498 43 26.6028 43 26.0498V14.0498C43 13.4968 43.447 13.0498 44 13.0498H52C52.553 13.0498 53 13.4968 53 14.0498V26.0498C53 26.6028 52.553 27.0498 52 27.0498ZM45 25.0498H51V15.0498H45V25.0498Z"
      fill={fill}
    />
    <path
      d="M48 27.0498C47.447 27.0498 47 26.6028 47 26.0498V14.0498C47 13.4968 47.447 13.0498 48 13.0498C48.553 13.0498 49 13.4968 49 14.0498V26.0498C49 26.6028 48.553 27.0498 48 27.0498Z"
      fill={fill}
    />
    <path
      d="M52 19.0498H44C43.447 19.0498 43 18.6028 43 18.0498C43 17.4968 43.447 17.0498 44 17.0498H52C52.553 17.0498 53 17.4968 53 18.0498C53 18.6028 52.553 19.0498 52 19.0498Z"
      fill={fill}
    />
    <path
      d="M52 23.0498H44C43.447 23.0498 43 22.6028 43 22.0498C43 21.4968 43.447 21.0498 44 21.0498H52C52.553 21.0498 53 21.4968 53 22.0498C53 22.6028 52.553 23.0498 52 23.0498Z"
      fill={fill}
    />
    <path
      d="M56.9989 7.0499C56.8349 7.0499 56.6679 7.0099 56.5149 6.9239L47.5149 1.9239C47.0319 1.6549 46.8579 1.0469 47.1259 0.5649C47.3939 0.0829 48.0039 -0.0931 48.4849 0.1759L57.4849 5.1759C57.9679 5.4449 58.1419 6.0529 57.8739 6.5349C57.6909 6.8639 57.3509 7.0499 56.9989 7.0499Z"
      fill={fill}
    />
    <path
      d="M39.0005 7.04982C38.6485 7.04982 38.3085 6.86382 38.1255 6.53482C37.8565 6.05282 38.0305 5.44382 38.5145 5.17582L47.5145 0.175819C47.9955 -0.0941815 48.6065 0.0818185 48.8735 0.564819C49.1425 1.04682 48.9685 1.65582 48.4845 1.92382L39.4845 6.92382C39.3315 7.00982 39.1645 7.04982 39.0005 7.04982Z"
      fill={fill}
    />
    <path
      d="M56.9989 11.0499C56.8349 11.0499 56.6679 11.0099 56.5149 10.9239L47.5149 5.92386C47.0319 5.65486 46.8579 5.04686 47.1259 4.56486C47.3939 4.08286 48.0039 3.90586 48.4849 4.17586L57.4849 9.17586C57.9679 9.44486 58.1419 10.0529 57.8739 10.5349C57.6909 10.8639 57.3509 11.0499 56.9989 11.0499Z"
      fill={fill}
    />
    <path
      d="M39.0005 11.0498C38.6485 11.0498 38.3085 10.8638 38.1255 10.5348C37.8565 10.0528 38.0305 9.44377 38.5145 9.17577L47.5145 4.17577C47.9955 3.90477 48.6065 4.08177 48.8735 4.56477C49.1425 5.04677 48.9685 5.65577 48.4845 5.92377L39.4845 10.9238C39.3315 11.0098 39.1645 11.0498 39.0005 11.0498Z"
      fill={fill}
    />
    <path
      d="M57 64.0498C56.447 64.0498 56 63.6028 56 63.0498V6.0498C56 5.4968 56.447 5.0498 57 5.0498C57.553 5.0498 58 5.4968 58 6.0498V63.0498C58 63.6028 57.553 64.0498 57 64.0498Z"
      fill={fill}
    />
    <path
      d="M46.0304 57.0498C45.4774 57.0498 45.0254 56.6028 45.0254 56.0498C45.0254 55.4968 45.4674 55.0498 46.0194 55.0498H46.0304C46.5824 55.0498 47.0304 55.4968 47.0304 56.0498C47.0304 56.6028 46.5824 57.0498 46.0304 57.0498Z"
      fill={fill}
    />
    <path
      d="M16 64.0498C15.447 64.0498 15 63.6028 15 63.0498V50.0498C15 49.4968 15.447 49.0498 16 49.0498C16.553 49.0498 17 49.4968 17 50.0498V63.0498C17 63.6028 16.553 64.0498 16 64.0498Z"
      fill={fill}
    />
    <path
      d="M8 64.0498C7.447 64.0498 7 63.6028 7 63.0498V50.0498C7 49.4968 7.447 49.0498 8 49.0498C8.553 49.0498 9 49.4968 9 50.0498V63.0498C9 63.6028 8.553 64.0498 8 64.0498Z"
      fill={fill}
    />
    <path
      d="M16 51.0498H8C7.447 51.0498 7 50.6028 7 50.0498C7 49.4968 7.447 49.0498 8 49.0498H16C16.553 49.0498 17 49.4968 17 50.0498C17 50.6028 16.553 51.0498 16 51.0498Z"
      fill={fill}
    />
    <path
      d="M16 64.0498H8C7.447 64.0498 7 63.6028 7 63.0498C7 62.4968 7.447 62.0498 8 62.0498H16C16.553 62.0498 17 62.4968 17 63.0498C17 63.6028 16.553 64.0498 16 64.0498Z"
      fill={fill}
    />
    <path
      d="M16 45.0498H8C7.447 45.0498 7 44.6028 7 44.0498V32.0498C7 31.4968 7.447 31.0498 8 31.0498H16C16.553 31.0498 17 31.4968 17 32.0498V44.0498C17 44.6028 16.553 45.0498 16 45.0498ZM9 43.0498H15V33.0498H9V43.0498Z"
      fill={fill}
    />
    <path
      d="M12 45.0498C11.447 45.0498 11 44.6028 11 44.0498V32.0498C11 31.4968 11.447 31.0498 12 31.0498C12.553 31.0498 13 31.4968 13 32.0498V44.0498C13 44.6028 12.553 45.0498 12 45.0498Z"
      fill={fill}
    />
    <path
      d="M16 37.0498H8C7.447 37.0498 7 36.6028 7 36.0498C7 35.4968 7.447 35.0498 8 35.0498H16C16.553 35.0498 17 35.4968 17 36.0498C17 36.6028 16.553 37.0498 16 37.0498Z"
      fill={fill}
    />
    <path
      d="M16 41.0498H8C7.447 41.0498 7 40.6028 7 40.0498C7 39.4968 7.447 39.0498 8 39.0498H16C16.553 39.0498 17 39.4968 17 40.0498C17 40.6028 16.553 41.0498 16 41.0498Z"
      fill={fill}
    />
    <path
      d="M16 27.0498H8C7.447 27.0498 7 26.6028 7 26.0498V14.0498C7 13.4968 7.447 13.0498 8 13.0498H16C16.553 13.0498 17 13.4968 17 14.0498V26.0498C17 26.6028 16.553 27.0498 16 27.0498ZM9 25.0498H15V15.0498H9V25.0498Z"
      fill={fill}
    />
    <path
      d="M12 27.0498C11.447 27.0498 11 26.6028 11 26.0498V14.0498C11 13.4968 11.447 13.0498 12 13.0498C12.553 13.0498 13 13.4968 13 14.0498V26.0498C13 26.6028 12.553 27.0498 12 27.0498Z"
      fill={fill}
    />
    <path
      d="M16 19.0498H8C7.447 19.0498 7 18.6028 7 18.0498C7 17.4968 7.447 17.0498 8 17.0498H16C16.553 17.0498 17 17.4968 17 18.0498C17 18.6028 16.553 19.0498 16 19.0498Z"
      fill={fill}
    />
    <path
      d="M16 23.0498H8C7.447 23.0498 7 22.6028 7 22.0498C7 21.4968 7.447 21.0498 8 21.0498H16C16.553 21.0498 17 21.4968 17 22.0498C17 22.6028 16.553 23.0498 16 23.0498Z"
      fill={fill}
    />
    <path
      d="M20.9989 7.0499C20.8349 7.0499 20.6679 7.0099 20.5149 6.9239L11.5149 1.9239C11.0319 1.6549 10.8579 1.0469 11.1259 0.5649C11.3939 0.0829 12.0039 -0.0931 12.4849 0.1759L21.4849 5.1759C21.9679 5.4449 22.1419 6.0529 21.8739 6.5349C21.6909 6.8639 21.3509 7.0499 20.9989 7.0499Z"
      fill={fill}
    />
    <path
      d="M3.00053 7.04982C2.64853 7.04982 2.30853 6.86382 2.12553 6.53482C1.85653 6.05282 2.03053 5.44482 2.51453 5.17582L11.5145 0.175819C11.9955 -0.0941815 12.6065 0.0818185 12.8735 0.564819C13.1425 1.04682 12.9685 1.65582 12.4845 1.92382L3.48453 6.92382C3.33153 7.00982 3.16453 7.04982 3.00053 7.04982Z"
      fill={fill}
    />
    <path
      d="M20.9989 11.0499C20.8349 11.0499 20.6679 11.0099 20.5149 10.9239L11.5149 5.92386C11.0319 5.65486 10.8579 5.04686 11.1259 4.56486C11.3939 4.08286 12.0039 3.90586 12.4849 4.17586L21.4849 9.17586C21.9679 9.44486 22.1419 10.0529 21.8739 10.5349C21.6909 10.8639 21.3509 11.0499 20.9989 11.0499Z"
      fill={fill}
    />
    <path
      d="M3.00053 11.0498C2.64853 11.0498 2.30853 10.8638 2.12553 10.5348C1.85653 10.0528 2.03053 9.44377 2.51453 9.17577L11.5145 4.17577C11.9955 3.90477 12.6065 4.08177 12.8735 4.56477C13.1425 5.04677 12.9685 5.65577 12.4845 5.92377L3.48453 10.9238C3.33153 11.0098 3.16453 11.0498 3.00053 11.0498Z"
      fill={fill}
    />
    <path
      d="M3 64.0498C2.447 64.0498 2 63.6028 2 63.0498V6.0498C2 5.4968 2.447 5.0498 3 5.0498C3.553 5.0498 4 5.4968 4 6.0498V63.0498C4 63.6028 3.553 64.0498 3 64.0498Z"
      fill={fill}
    />
    <path
      d="M10.0304 57.0498C9.47739 57.0498 9.02539 56.6028 9.02539 56.0498C9.02539 55.4968 9.46739 55.0498 10.0194 55.0498H10.0304C10.5824 55.0498 11.0304 55.4968 11.0304 56.0498C11.0304 56.6028 10.5824 57.0498 10.0304 57.0498Z"
      fill={fill}
    />
    <path
      d="M59 64.0498H1C0.447 64.0498 0 63.6028 0 63.0498C0 62.4968 0.447 62.0498 1 62.0498H59C59.553 62.0498 60 62.4968 60 63.0498C60 63.6028 59.553 64.0498 59 64.0498Z"
      fill={fill}
    />
  </svg>
)

export default Coop
